<script lang="ts">
    import ProjectsPage from '@Projects/Pages/ProjectsPage'
    export default ProjectsPage
</script>

<template>
    <div>
        <DecisionProjectBuilder :viewModel="decisionProjectBuilder" 
                                @create-decision="handleCreateDecisionProjectCommand" />

        <PortfolioProjectBuilder :viewModel="portfolioProjectBuilder" 
                                 @create-portfolio="handleCreatePortfolioProjectCommand" />

        <ProjectCloner :viewModel="projectCloner" 
                       @clone-project="handleCloneProjectCommand" />       
        
        <ProjectEditor :viewModel="projectEditor" 
                       @update-project="handleUpdateProjectCommand"
                       @delete-project="handleDeleteProjectCommand" />
        
        <ProjectTemplateLinksManager :viewModel="projectTemplateLinksManager"
                                     @update-links="handleUpdateProjectTemplateLinksCommand" />

        <ProjectWorkspaceSwitcher v-if="projectWorkspaceSwitcher"
                                  :viewModel="projectWorkspaceSwitcher" 
                                  @move-project="handleSwitchProjectWorkspaceCommand" />

        <div style="padding-top: 130px;">
            <WorkspaceNavigation :workspaceId="workspaceId" :workspaceName="workspaceName" />

            <div class="container-fluid">
                <h3 v-if="!initialized"><i class="fa fa-spinner fa-spin"></i> Loading... </h3>
                <div v-if="initialized">
                    <div class="d-flex">
                        <div class="pr-1 flex-grow-1">
                            <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin: 0;">
                                {{workspaceName}}
                            </h1>
                        </div>
                        <div class="pr-1">
                            <button class="btn btn-success" @click="showPortfolioBuilder">
                                Create Portfolio
                            </button>
                        </div>
                        <div class="pr-1">
                            <button class="btn btn-secondary" @click="showDecisionBuilder">
                                Make Decision
                            </button>
                        </div>
                        <div class="pr-1">
                            <a class="btn btn-outline-secondary" href="https://www.transparentchoice.com/user-guide/getting-started" title="User guide: Getting started" target="_blank">
                                <i class="fa fa-info" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>

                    <hr style="border-color: #bbb; margin: 20px 0 60px;" />


                    <div v-if="projects.length === 0">
                        <p class="lead">You don't have any projects yet.</p>
                    </div>

                    <nav v-if="projects.length > 0" class="navbar navbar-expand-lg navbar-light bg-light">
                        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#ProjectsTpl_NavigationBar" aria-expanded="false" aria-label="Toggle navigation">
                            <span class="navbar-toggler-icon"></span>
                        </button>
                        <div class="collapse navbar-collapse" id="ProjectsTpl_NavigationBar">
                            <ul class="navbar-nav">
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown">
                                        Order by {{ orderBy }}
                                        <i v-if="!orderByDescending" class="fa fa-sort-alpha-asc"></i>
                                        <i v-if="orderByDescending" class="fa fa-sort-alpha-desc"></i>
                                    </a>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" @click="orderByName">Name</a>
                                        <a class="dropdown-item" @click="orderByCreated">Date of creation</a>
                                        <a class="dropdown-item" @click="orderByLastActivity">Last activity</a>
                                    </div>
                                </li>
                            </ul>
                            <form class="form-inline my-2 my-lg-0 ml-2" role="search">
                                <div class="input-group input-group-sm">
                                    <input v-model="searchPhrase" class="form-control form-control-sm" type="search" placeholder="Search">
                                    <span class="input-group-append"><span class="input-group-text"><i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i></span></span>
                                </div>
                            </form>
                        </div>
                    </nav>

                    <div style="padding-bottom: 50px; margin-top: 20px;">
                        <div class="row">
                            <div class="col-md-4 col-sm-6" v-for="p in projectsView" :key="p.ProjectId">
                                <div class="tile bg-color-gray5" style="margin-bottom: 20px; padding: 8px;">
                                    <div class="dropdown float-right">
                                        <a data-toggle="dropdown" class="text-dark">
                                            <i class="fa fa-ellipsis-h"></i>
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <a class="dropdown-item" v-sanitizedHref="`/#/project/${p.ProjectId}`">Open</a>
                                            <a class="dropdown-item" @click="showProjectEditor(p)">Edit or delete</a>
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item" @click="showProjectCloner(p)">Clone</a>
                                            <a class="dropdown-item" @click="showProjectTemplateLinksManager(p)">Share as a template</a>
                                            <a class="dropdown-item" @click="showProjectWorkspaceSwitcher(p)">Move to a workspace</a>
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item" @click="exportToJson(p)">Export to JSON</a>
                                        </div>
                                    </div>

                                    <h5 class="text-ellipsis font-weight-light" style="margin-top: 7px;">
                                        <a class="text-dark" v-sanitizedHref="`/#/project/${p.ProjectId}`">{{p.Name}}</a>
                                    </h5>

                                    <p class="text-ellipsis fg-color-gray1">
                                        {{p.Description}} &nbsp;
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>
